











import {Component, Vue, Prop} from 'vue-property-decorator';
import {VIcon} from 'vuetify/lib';

@Component({
	components: {
		VIcon,
	},
})
export default class AppartmentDetails extends Vue {
	@Prop() private icon!: string;
}
